module.exports = __webpack_public_path__ + "img/searching.818b0bc3.png";